/*@ngInject*/
const CollaborationLoadTaskRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadCollaborationTask = function (taskId) {
        let url = '/rest/SubmissionTask/' + taskId;

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('collaborationLoadTaskRepository', CollaborationLoadTaskRepository);
